export function isInWebView() {
  const ua = navigator.userAgent || navigator.vendor || '';
  const isAndroid = /Android/i.test(ua);
  const isIOS =
    /iPhone|iPod|iPad/i.test(ua) ||
    (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);

  if (!isAndroid && !isIOS) return false;

  if (
    isIOS &&
    window.navigator &&
    'standalone' in window.navigator &&
    window.navigator.standalone
  ) {
    return true;
  }

  const inAppMarkers =
    /(FBAN|FBAV|FBIOS|FBSS|Instagram|Line|MicroMessenger|Snapchat|TikTok)/i;
  if (inAppMarkers.test(ua)) return true;

  if (isIOS) {
    if (
      /CriOS/i.test(ua) ||
      /FxiOS/i.test(ua) ||
      /EdgiOS/i.test(ua) ||
      /OPiOS/i.test(ua) ||
      /YaBrowser/i.test(ua)
    ) {
      return false;
    }
    const isSafari =
      /Safari/i.test(ua) && /Mobile/i.test(ua) && /Version/i.test(ua);

    if (isSafari) return false;

    return true;
  }

  if (isAndroid) {
    if (ua.indexOf('; wv)') !== -1 || ua.indexOf(') wv') !== -1) return true;

    if (/Version\/(\d+)\.(\d+).+Chrome\//i.test(ua)) return true;

    if (/Chrome\/\d/i.test(ua) || /CriOS/i.test(ua)) return false;

    if (/Firefox\/\d/i.test(ua)) return false;

    if (/SamsungBrowser/i.test(ua) || /MiuiBrowser/i.test(ua)) return false;

    if (/OPR\//i.test(ua) || /Opera/i.test(ua)) return false;

    if (/EdgA?/i.test(ua)) return false;

    return true;
  }

  return false;
}
